// extracted by mini-css-extract-plugin
module.exports = {"container":"Period_container__38uWi","from-text":"Period_from-text__1WEbA","to-label":"Period_to-label__23sQD","to-text":"Period_to-text__38v8R"};